<template>
  <div class="pt-card-controls">
    <el-button class="r-button" type="info" @click="cancel" block>
      Отменить
    </el-button>
    <el-button
      class="r-button"
      type="primary"
      @click="save"
      :disabled="disabled"
    >
      Применить
    </el-button>
  </div>
</template>

<script>
export default {
  props: ["save", "cancel", "feature", "required"],
  computed: {
    disabled() {
      return this.required.some(prop => !this.feature[prop]);
    }
  }
};
</script>

<style lang="scss">
.pt-card-controls {
  margin-top: 16px;
  display: flex;

  .el-button {
    flex: 1;

    &:last-child {
      margin-left: 16px;
    }
  }
}
</style>
